import { render, staticRenderFns } from "./_Payments.vue?vue&type=template&id=f8c55c32&scoped=true"
import script from "./_Payments.vue?vue&type=script&lang=js"
export * from "./_Payments.vue?vue&type=script&lang=js"
import style0 from "./_Payments.vue?vue&type=style&index=0&id=f8c55c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c55c32",
  null
  
)

export default component.exports